import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Device } from 'app/models/device.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeviceService {

    device: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }


    getDevices(companyId: number): Promise<Array<Device>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "devices/" + companyId)
                .subscribe((response: any) => {
                    this.device = response;
                    this.onChanged.next(this.device);
                    resolve(response);
                }, reject);
        });
    }

    getByDevice(id: string): Promise<Device> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "devices/devicebyid/" + id)
                .subscribe((response: any) => {
                    this.device = response;
                    this.onChanged.next(this.device);
                    resolve(response);
                }, reject);
        });
    }

    deviceContol(): Promise<Array<Device>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "devices/deviceControl")
                .subscribe((response: any) => {
                    this.device = response;
                    this.onChanged.next(this.device);
                    resolve(response);
                }, reject);
        });
    }

    getFilterDevice(id: string, companyId: number): Promise<Array<Device>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "devices/filter/" + id + "/" + companyId)
                .subscribe((response: any) => {
                    this.device = response;
                    this.onChanged.next(this.device);
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Device): Promise<Device> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "devices/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(entity: Device): Promise<Device> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "devices/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updateRange(devices: Array<Device>): Promise<Device> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "devices/updateRange", devices)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    delete(entity: Device): Promise<Device> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "devices/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }



    allChangeFirmwareUpdateCheck(company_id: number): Promise<Device> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "devices/allchangefirmwareupdatecheck", company_id)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
